var map = {
	"./fire.gif": "b1f9",
	"./icon_horse.svg": "2884",
	"./icon_invest.svg": "d8c5",
	"./icon_lottery.svg": "ddfa",
	"./icon_sportMenu_UEFA.svg": "8540",
	"./icon_sportMenu_badminton.svg": "3623",
	"./icon_sportMenu_baseball.svg": "afcc",
	"./icon_sportMenu_basketball.svg": "8fd8",
	"./icon_sportMenu_billiard.svg": "e5ca",
	"./icon_sportMenu_boxing.svg": "c824",
	"./icon_sportMenu_champion.svg": "547a",
	"./icon_sportMenu_fives.svg": "f840",
	"./icon_sportMenu_football.svg": "380a",
	"./icon_sportMenu_handball.svg": "1bda",
	"./icon_sportMenu_hockey.svg": "c59a",
	"./icon_sportMenu_hot.png": "024a",
	"./icon_sportMenu_pcgame.svg": "e0d2",
	"./icon_sportMenu_pingpong.svg": "e639",
	"./icon_sportMenu_soccer.svg": "ceb5",
	"./icon_sportMenu_star.svg": "ede9",
	"./icon_sportMenu_tennis.svg": "4871",
	"./icon_sportMenu_volleyball.svg": "81fe",
	"./icon_sportMenu_waterpolo.svg": "5b83",
	"./icon_sportMenu_worldCup.svg": "8c5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c2dc";